import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Edit = forwardRef<Ref, IconPropsType>(({ color = "currentColor", size, ...rest }, ref) => {
  return (
    <svg
      width={size ?? 16}
      height={size ?? 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.52729 8.47139L12.3606 1.63804C12.621 1.37769 13.0431 1.37769 13.3034 1.63804L14.3606 2.69524C14.621 2.95558 14.621 3.3777 14.3606 3.63804L7.5273 10.4714C7.4023 10.5964 7.2327 10.6667 7.0559 10.6667H5.66536C5.48127 10.6667 5.33203 10.5174 5.33203 10.3333V8.94279C5.33203 8.76599 5.40227 8.59639 5.52729 8.47139Z"
        fill={color}
      />
      <path
        d="M6.66536 2.66664C6.66536 3.03483 6.36689 3.33331 5.9987 3.33331H2.66536V13.3333H12.6654V9.99999C12.6654 9.63179 12.9638 9.33332 13.332 9.33332C13.7002 9.33332 13.9987 9.63179 13.9987 9.99999V13.3333C13.9987 14.0697 13.4018 14.6667 12.6654 14.6667H2.66536C1.92898 14.6667 1.33203 14.0697 1.33203 13.3333V3.33331C1.33203 2.59692 1.92898 1.99997 2.66536 1.99997H5.9987C6.36689 1.99997 6.66536 2.29845 6.66536 2.66664Z"
        fill={color}
      />
    </svg>
  );
});

export default Edit;
